import {
  Flex,
  Button,
  Text,
  HStack,
  IconButton,
  useBreakpointValue
} from "@chakra-ui/react";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { WeekNavigationData } from "../../types/Calendar";

interface WeekNavigatorProps {
  navigationData: WeekNavigationData;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  onCurrentWeek: () => void;
}

export function WeekNavigator({
  navigationData,
  onPreviousWeek,
  onNextWeek,
  onCurrentWeek
}: WeekNavigatorProps) {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Flex
      w="100%"
      justify="space-between"
      align="center"
      bg="white"
      p="2"
      borderRadius="md"
      boxShadow="sm"
      mb="4"
    >
      <HStack spacing="2">
        <Button
          size="sm"
          variant="outline"
          colorScheme="blue"
          onClick={onCurrentWeek}
          borderRadius={50}
        >
          Hoje
        </Button>

        <IconButton
          aria-label="Semana anterior"
          icon={<RiArrowLeftSLine />}
          onClick={onPreviousWeek}
          isDisabled={!navigationData.hasPrevious}
          variant="outline"
          colorScheme="blue"
          size="sm"
          isRound
        />

        <IconButton
          aria-label="Próxima semana"
          icon={<RiArrowRightSLine />}
          onClick={onNextWeek}
          isDisabled={!navigationData.hasNext}
          variant="outline"
          colorScheme="blue"
          size="sm"
          isRound
        />

        <Text
          fontSize="md"
          fontWeight="bold"
          color="blue.900"
          textAlign="center"
        >
          {navigationData.currentWeekFormatted}
        </Text>
      </HStack>

      <HStack spacing="2">

        <Text
          fontSize="sm"
          color="gray.600"
          display={isMobile ? "none" : "block"}
        >
          Semana {navigationData.currentWeekIndex + 1} de {navigationData.totalWeeks}
        </Text>
      </HStack>
    </Flex>
  );
}
